import { Section, Eyebrow, Heading, P, PullQuote } from "../Chapter";

export const Telegram = () => (
    <Section>
        <Eyebrow>V. An ending</Eyebrow>
        <Heading>The last telegram</Heading>

        <P>On the night of 14 July 2013, India sent its final telegram.</P>
        <P delay={0.05}>
            The service had run for over 160 years. It carried independence, partition, three wars,
            and roughly a century of the two sentences that mattered most in any family: someone has
            died, or someone has arrived safely. Telegrams were charged by the word, so people
            learned to compress grief into four of them.
        </P>
        <P delay={0.05}>
            That last night, the offices were full. People queued for hours to send a telegram to
            themselves, or to a child, so that someone in the family would own one. Operators who
            had worked the keys for thirty years sent the final messages and then sat with nothing
            to do.
        </P>

        <PullQuote>
            A technology doesn't usually get a funeral. This one did, and people came.
        </PullQuote>

        <P>
            Nobody mourned the telegram when it was useful. It was expensive, terse, and usually the
            bearer of terrible news. They mourned it when it stopped — because it was the last
            machine that made you choose your words carefully by charging you for every one.
        </P>
    </Section>
);
